import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useReducerAsync} from 'use-reducer-async';
import * as notificationsActions from '../../actions/notifications';
import ClientsContainer from './ClientsContainer';
import getAsyncActionHandlers from './store/asyncActionHandlers';
import reducer from './store/reducer';

const pageSize = 10;

const initialState = {
  depositor: {
    isActive: false,
    loading: true
  },
  clients: {
    list: [],
    loading: true,
    error: false,
    totalCount: 0,
    pageSize
  },
  sentInvitations: {
    list: [],
    loading: true,
    error: false
  }
};
const store = React.createContext(initialState);
export const useClientsStore = () => React.useContext(store);

function ClientsStore() {
  const [organisation, user] = useSelector(globalState => [
    globalState.organisation,
    globalState.user
  ]);
  const globalDispatch = useDispatch();
  const fetchNotificationsAction = actionParams => globalDispatch(notificationsActions.fetchNotifications(actionParams));
  const params = {
    depositor: organisation.depositor,
    organisationId: organisation.organisationId,
    userId: user.id,
    pageSize
  };

  const {Provider} = store;

  const [state, dispatch] = useReducerAsync(
    reducer,
    initialState,
    getAsyncActionHandlers(params, fetchNotificationsAction)
  );

  return (
    <Provider value={{state, dispatch}}>
      <ClientsContainer/>
    </Provider>
  );
}

export default ClientsStore;
